"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuteButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
const VolumeOffIcon_1 = require("../../../icons/VolumeOffIcon");
const VolumeOnIcon_1 = require("../../../icons/VolumeOnIcon");
const IconButton_1 = require("../IconButton");
const MuteButton_module_css_1 = __importDefault(require("./MuteButton.module.css"));
/**
 *
 */
function MuteButton({ onClick, isMuted, className = "" }) {
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.default)(MuteButton_module_css_1.default.muteButton, className), "data-testid": "muteButton", children: (0, jsx_runtime_1.jsx)(IconButton_1.IconButton, { size: "SMALL", label: "Mute", onClick: onClick, children: isMuted ? (0, jsx_runtime_1.jsx)(VolumeOffIcon_1.VolumeOffIcon, {}) : (0, jsx_runtime_1.jsx)(VolumeOnIcon_1.VolumeOnIcon, {}) }) }));
}
exports.MuteButton = MuteButton;
//# sourceMappingURL=MuteButton.js.map